import { render, staticRenderFns } from "./FilesMain.vue?vue&type=template&id=39723c7e&scoped=true&"
import script from "./FilesMain.vue?vue&type=script&lang=js&"
export * from "./FilesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39723c7e",
  null
  
)

export default component.exports